import { render, staticRenderFns } from "./TabsSideNav.vue?vue&type=template&id=3c93ccbf&"
import script from "./TabsSideNav.vue?vue&type=script&lang=js&"
export * from "./TabsSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports